// src/pages/Home.js
import React from 'react';

function Home() {
  return (
    <div className="w3-container">
      <h1 className="w3-center">Home</h1>
        <div class="w3-container w3-center">
        <img src="https://picsum.photos/id/1015/300/200" class="w3-image w3-round w3-hover-grayscale responsive" alt="Home" />
        </div>

      <p>Coxswain fluke Jolly Roger gangway strike colors sutler mizzen bowsprit stern. Lateen sail grapple boom tackle loot Sea Legs gangplank chantey sloop. Blimey hornswaggle parley mutiny gunwalls crow's nest plunder blow the man down fire ship.</p>
      <p>Sail ho trysail rum pinnace tender ho crow's nest Jolly Roger yawl. Hardtack maroon spirits chase guns shrouds chase interloper chantey cackle fruit. Trysail landlubber or just lubber Barbary Coast pirate jack hang the jib wench plunder sheet.</p>
    </div>
  )
}

export default Home;